import { render, staticRenderFns } from "./AddAttachments.vue?vue&type=template&id=ca0ff20e&scoped=true"
import script from "./AddAttachments.vue?vue&type=script&lang=js"
export * from "./AddAttachments.vue?vue&type=script&lang=js"
import style0 from "./AddAttachments.vue?vue&type=style&index=0&id=ca0ff20e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0ff20e",
  null
  
)

export default component.exports